export const traducciones = {
    es: {
      contact: "Contacto",
      home: "Inicio",
      solutions: "Soluciones",
      about: "Nosotros",
      // Añade aquí más traducciones para toda la aplicación
    },
    en: {
      contact: "Contact",
      home: "Home",
      solutions: "Solutions",
      about: "About us",
    }
  };